<!--
 * @Autor: yingna.gao
 * @Date: 2022-11-01 15:20:31
 * @LastEditTime: 2022-12-17 16:37:02
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/dynamic-page/dynamic-page-list.vue
-->
<template>
  <div class="app-wrap">
    <TreeListLayoutAdapter :left-panel-enable="false" :right-top-panel-enable="false">
      <template #search>
        <div class="unPb24">
          <!-- 表格搜索 -->
          <search-currency v-if="searchQueryParam.length > 0" :search-query-param="searchQueryParam" @search="handleSearch" @reset="handleSearch" />
        </div>
      </template>
      <template #datatable>
        <div  class="h100">
          <GeneralTable
            v-if="tableCode && tableColumns.length"
            ref="customTable"
            :code="tableCode"
            :loading="tableLoading"
            :version="2"
            :data="tableData"
            :pagination="pagination"
            :operable="false"
            :columns="tableColumns"
            @refresh="handleRefresh"
            @handleSizeChange="handlePaginationChange"
            @handleCurrentChange="handlePaginationChange"
          >
            <div slot="tableSearchContent" class="clearfix" style="padding-bottom:8px">
              <el-button class="float-right" type="primary" @click="exportExcel" >{{ $t("public.export") }}</el-button>
            </div>
          </GeneralTable>
        <!-- /表格 -->
        </div>
      </template>
    </TreeListLayoutAdapter>
  </div>
</template>

<script>
import SearchCurrency from "@/components/private/search-currency";
import reportConfigApi from "@/api/report-config/index";
export default {
  name: "DynamicPageList",
  components: {
    SearchCurrency
  },
  data() {
    return {
      tableLoading: false,
      searchForm: {
      },
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableColumns: [],
      tableCode: ``,
      tableVersion: 1,
      tableSortCustom: [],
      tableSortDisabled: [],
      searchQueryParam: [],
      pageCode: ""
    };
  },
  async created() {
    const { path } = this.$route;
    const list = path.split("/dynamic-page/") || [];
    this.pageCode = list.length > 1 ? list[1] : "";
    this.tableCode = `DYBANICT_PAGE_LIST${this.pageCode}`;
    await this.getConfigSearch();
    // 获取组织树
    this.getList();
  },
  activated() {
    this.getList();
  },
  methods: {
    getConfigSearch() {
      const params = {
        reportConfigCode: this.pageCode
      };
      return reportConfigApi.getConfigSearch(params).then(res => {
        if (res.success && res.data) {
          const { reportFilterParamDTOList, reportColumnConfigDTOList } = res.data;
          const hasSearchJsonList = reportFilterParamDTOList.filter(searchItem => searchItem.columnFilterJson);
          this.searchQueryParam = hasSearchJsonList.map(searchItem => JSON.parse(searchItem.columnFilterJson));
          this.tableColumns = reportColumnConfigDTOList.map(col => ({
            label: col.columnTitle,
            key: col.columnName,
            width: "auto",
            fixed: false,
            minWidth: "100px",
            hidden: false
          }));
        }
      });
    },
    getList() {
      const reportFilterParamDTOList = [];
      for (const key in this.searchForm) {
        const searchItemObj = this.searchQueryParam.find(searchItem => searchItem.searchItemBindingFlag === key);
        reportFilterParamDTOList.push({
          columnName: key,
          fieldValue: this.searchForm[key],
          searchItemType: searchItemObj ? searchItemObj.searchItemType : ""
        });
      }
      const params = {
        query: {
          page: this.pagination.pageNum,
          size: this.pagination.pageSize
        },
        body: {
          dynamicReportConfigCode: this.pageCode,
          reportFilterParamDTOList
        }
      };
      reportConfigApi.getDynamicReportList(params).then(res => {
        if (res.data) {
          const { records = [], total = 0 } = res.data;
          this.tableData = records;
          this.pagination.total = Number(total);
        }
      });
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    handleSearch(searchValue) {
      this.pagination.total = 0;
      this.pagination.pageNum = 1;
      this.tableData = [];
      this.searchForm = searchValue;
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    },
    // table刷新
    handleRefresh() {
      this.$emit("refresh");
    },
    // 文件导出
    exportExcel() {
      const reportFilterParamDTOList = [];
      for (const key in this.searchForm) {
        const searchItemObj = this.searchQueryParam.find(searchItem => searchItem.searchItemBindingFlag === key);
        reportFilterParamDTOList.push({
          columnName: key,
          fieldValue: this.searchForm[key],
          searchItemType: searchItemObj ? searchItemObj.searchItemType : ""
        });
      }
      const params = {
        dynamicReportConfigCode: this.pageCode,
        reportFilterParamDTOList
      };
      reportConfigApi.executeReportExport(params).then(result => {
        this.$store.commit("settings/CHANGE_EXPORT_TASK", true);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.unPb24{
  padding:24px 24px 0 24px;
}
.app-wrap {
  width: 100%;
  height: 100%;
}

.self-drag-right {
  background-color: #fff;
  padding: 20px;
  .r-b-title {
    margin-bottom: 16px;
  }
}
::v-deep.self-filter-input .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
</style>

